import "./financial.css"
import financial from "../../../assets/financial.webp"
import React, {useEffect, useState} from "react";
import Form from "react-bootstrap/Form";
import {Link, useNavigate} from "react-router-dom";
import {setFinancialInfo} from "../../../redux/financial_store";
import {setPersonalData} from "../../../redux/personal_store";
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";
import Logout from "../../logout/Logout";
import {Spinner} from "react-bootstrap";
import apiClient from "../../../utils/axios";
import {setAccountType} from "../../../redux/account_store";
import ProgressBar from "react-bootstrap/ProgressBar";

const HOST = `${process.env.REACT_APP_API_URL}/api/accounts/step2/`

function FinancialInfo({financialInfo, setAccountType, setFinancialInfo, appData, personalData}) {

    const campaignSlug = window.campaign_slug || ''

    const {t} = useTranslation()

    const navigate = useNavigate()
    const [isReadyCountry, setIsReadyCountry] = useState(false)
    const [isReadyState, setIsReadyState] = useState(false)
    const [countries, setCountries] = useState([]);
    const [states, setState] = useState([])
    const now = 30;

    const [financialErrors, setFinancialErrors] = useState({
        emplStatus: '',
        sourceOfIncome: '',
        sourceOfWealth: '',
        annualIncome: '',
        assets: '',
        netWorth: '',
        schoolName: '',
        occupation: '',
        companyName: '',
        businessAddress: '',
        city: '',
        zipCode: '',
        countryName: '',
        businessState: '',
        businessPhone: '',
        soldBusinessName: '',
        soldAmount: '',
        soldBusinessDate: ''
    });

    useEffect(() => {

        apiClient.get(`${process.env.REACT_APP_API_URL}/api/getCountries`, {
                headers: {
                    "ngrok-skip-browser-warning": "69420",
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            }
        )
            .then(({data}) => {
                const countryNames = data.map((country) => {
                    return {
                        value: country.cont_code,
                        label: country.cont_name
                    }
                });

                setCountries(countryNames);
                setIsReadyCountry(true)

            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);

    useEffect(() => {
        if (countries.length) {
            if (financialInfo.businessState) {
                getStates(financialInfo.countryName)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [countries]);

    const getStates = async (country) => {
        setIsReadyState(false);
        const countryObject = countries.find(i => i.value === country || i.label === country);

        if (!countryObject) {
            setIsReadyState(true);
            return;
        }

        try {
            const response = await apiClient.get(`${process.env.REACT_APP_API_URL}/api/getStates/${countryObject.value}`, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            });

            const stateData = response.data;
            const stateNames = stateData.map((state) => ({
                subdivision_name: state.subdivision_name,
                code: state.code
            }));

            setIsReadyState(true);

            setState(stateNames);

        } catch (err) {
            console.log(err.message);
        }
    }

    const onChangeCountry = async (value) => {
        setFinancialInfo({...financialInfo, 'countryName': value});
        await getStates(value)
    }

    const onChangeState = (value) => {
        setFinancialInfo({...financialInfo, 'businessState': value});
    }

    const isValidDate = (dateString) => {
        const regex = /^\d{2}\/\d{2}\/\d{4}$/;

        if (!regex.test(dateString)) {
            return false;
        }

        const parts = dateString.split('/');
        const year = parseInt(parts[2], 10)
        const month = parseInt(parts[0], 10) - 1;
        const day = parseInt(parts[1], 10);
        const date = new Date(year, month, day);

        return (
            date.getDate() === day &&
            date.getMonth() === month &&
            date.getFullYear() === year
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setFinancialErrors({
            emplStatus: '',
            sourceOfIncome: '',
            sourceOfWealth: '',
            annualIncome: '',
            assets: '',
            netWorth: '',
            schoolName: '',
            occupation: '',
            companyName: '',
            businessAddress: '',
            city: '',
            zipCode: '',
            countryName: '',
            businessState: '',
            businessPhone: '',
            soldBusinessName: '',
            soldAmount: '',
            soldBusinessDate: ''
        });

        let isValid = true;

        if (appData.account_type !== "speciality") {
            if (!financialInfo.emplStatus) {
                setFinancialErrors((prevErrors) => ({
                    ...prevErrors,
                    emplStatus: t('errors.required_field'),
                }));
                isValid = false;
            }
        }

        if (!financialInfo.sourceOfIncome) {
            setFinancialErrors((prevErrors) => ({
                ...prevErrors,
                sourceOfIncome: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!financialInfo.sourceOfWealth) {
            setFinancialErrors((prevErrors) => ({
                ...prevErrors,
                sourceOfWealth: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (financialInfo.sourceOfWealth === "BusinessSale") {
            if (!financialInfo.soldAmount) {
                setFinancialErrors((prevErrors) => ({
                    ...prevErrors,
                    soldAmount: t('errors.required_field'),
                }));
                isValid = false;
            }

            if (!financialInfo.soldBusinessDate || !isValidDate(financialInfo.soldBusinessDate)) {
                setFinancialErrors((prevErrors) => ({
                    ...prevErrors,
                    soldBusinessDate: t('errors.required_field'),
                }));
                isValid = false;
            } else {
                const currentDate = new Date();
                const selectedBusinessDate = new Date(financialInfo.soldBusinessDate);

                if (selectedBusinessDate > currentDate) {
                    setFinancialErrors((prevErrors) => ({
                        ...prevErrors,
                        soldBusinessDate: t('errors.exp_earlier_date_error'),
                    }));
                    isValid = false;
                }
            }

            if (!financialInfo.soldBusinessName) {
                setFinancialErrors((prevErrors) => ({
                    ...prevErrors,
                    soldBusinessName: t('errors.required_field'),
                }));
                isValid = false;
            }
        }

        if (financialInfo.annualIncome === 'A' && campaignSlug === '42343') {
            setFinancialErrors((prevErrors) => ({
                ...prevErrors,
                annualIncome: t('errors.low_income_error'),
            }));
            isValid = false;
        } else if (!financialInfo.annualIncome) {
            setFinancialErrors((prevErrors) => ({
                ...prevErrors,
                annualIncome: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!financialInfo.assets) {
            setFinancialErrors((prevErrors) => ({
                ...prevErrors,
                assets: t('errors.required_field'),
            }));
            isValid = false;
        } else if (financialInfo.assets > financialInfo.netWorth) {
            setFinancialErrors((prevErrors) => ({
                ...prevErrors,
                assets: t('errors.liquid_assets_error'),
            }));
            isValid = false;
        } else if ((financialInfo.assets === 'A' || financialInfo.assets === 'B') && campaignSlug === '42343') {
            setFinancialErrors((prevErrors) => ({
                ...prevErrors,
                assets: t('errors.low_assets_error'),
            }));
            isValid = false;
        }

        if (!financialInfo.occupation && (financialInfo.emplStatus === 'Employed' || financialInfo.emplStatus === 'SelfEmployed')) {
            setFinancialErrors((prevErrors) => ({
                ...prevErrors,
                occupation: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!financialInfo.companyName && (financialInfo.emplStatus === 'Employed' || financialInfo.emplStatus === 'SelfEmployed')) {
            setFinancialErrors((prevErrors) => ({
                ...prevErrors,
                companyName: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!financialInfo.schoolName && financialInfo.emplStatus === 'Student') {
            setFinancialErrors((prevErrors) => ({
                ...prevErrors,
                schoolName: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!financialInfo.businessAddress && (financialInfo.emplStatus === 'Employed' || financialInfo.emplStatus === 'SelfEmployed')) {
            setFinancialErrors((prevErrors) => ({
                ...prevErrors,
                businessAddress: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!financialInfo.city && (financialInfo.emplStatus === 'Employed' || financialInfo.emplStatus === 'SelfEmployed')) {
            setFinancialErrors((prevErrors) => ({
                ...prevErrors,
                city: t('errors.required_field'),
            }));
            isValid = false;
        }

        const zipCodeRegex = /^\d{5}(-\d{4})?$/;
        if (financialInfo.countryName === 'USA') {
            if (!zipCodeRegex.test(financialInfo.zipCode) && (financialInfo.emplStatus === 'Employed' || financialInfo.emplStatus === 'SelfEmployed')) {
                setFinancialErrors((prevErrors) => ({
                    ...prevErrors,
                    zipCode: t('errors.zip_code_format'),
                }));
                isValid = false;
            }
        }

        if (!financialInfo.countryName && (financialInfo.emplStatus === 'Employed' || financialInfo.emplStatus === 'SelfEmployed')) {
            setFinancialErrors((prevErrors) => ({
                ...prevErrors,
                countryName: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!financialInfo.businessState && (financialInfo.emplStatus === 'Employed' || financialInfo.emplStatus === 'SelfEmployed')) {
            setFinancialErrors((prevErrors) => ({
                ...prevErrors,
                businessState: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!financialInfo.businessPhone && (financialInfo.emplStatus === 'Employed' || financialInfo.emplStatus === 'SelfEmployed')) {
            setFinancialErrors((prevErrors) => ({
                ...prevErrors,
                businessPhone: t('errors.required_field'),
            }));
            isValid = false;
        }

        if (!financialInfo.netWorth) {
            setFinancialErrors((prevErrors) => ({
                ...prevErrors,
                netWorth: t('errors.required_field'),
            }));
            isValid = false;
        } else if ((financialInfo.netWorth === 'A' || financialInfo.netWorth === 'B') && campaignSlug === '42343') {
            setFinancialErrors((prevErrors) => ({
                ...prevErrors,
                netWorth: t('errors.low_worth_error'),
            }));
            isValid = false;
        }

        if (isValid) {
            setFinancialInfo(financialInfo);
            if (!appData.app_id)
                alert('Missing app id')

            try {
                await financialApp()
                navigate('/affiliation')
            } catch (error) {
                setFinancialInfo((prevErrors) => ({
                    ...prevErrors,
                    submitError: error.message,
                }));
            }
        }
    }

    const handleInputChange = (e) => {
        let {name, value} = e.target;

        setFinancialInfo({...financialInfo, [name]: value});
        if (name === 'assets') {
            if (value === "A") {
                setAccountType('cashAcc')
            } else {
                setAccountType('marginAcc')
            }
        }

        if (name === 'soldBusinessDate') {
            const numericValue = value.replace(/\D/g, '');

            if (numericValue.length <= 2) {
                value = numericValue;
            } else if (numericValue.length <= 4) {
                value = `${numericValue.substr(0, 2)}/${numericValue.substr(2)}`;
            } else {
                value = `${numericValue.substr(0, 2)}/${numericValue.substr(2, 2)}/${numericValue.substr(4, 4)}`;
            }

            const isValid = isValidDate(value);

            setFinancialErrors((prevErrors) => ({
                ...prevErrors,
                [name]: isValid ? '' : t('errors.valid_date'),
            }));

            if (isValid) {
                const currentDate = new Date();
                const dateValue = new Date(value);

                if (name === 'soldBusinessDate') {
                    if (dateValue > currentDate) {
                        setFinancialErrors((prevErrors) => ({
                            ...prevErrors,
                            [name]: t('errors.exp_earlier_date_error'),
                        }));
                    }
                }
            }
        }

        if (name === 'zipCode') {
            value = value.replace(/\D/g, '').substr(0, 9);

            if (value.length === 9) {
                value = `${value.substr(0, 5)}-${value.substr(5, 4)}`;
            }

            const zipCodeRegex = /^\d{5}(-\d{4})?$/;
            if (!zipCodeRegex.test(value)) {
                setFinancialErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: t('errors.zip_code_format'),
                }));
            } else {
                setFinancialErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: '',
                }));
            }
        }

        setFinancialInfo({
            ...financialInfo,
            [name]: value,
        });

    };

    const formatDateInput = (dateString) => {
        if (!dateString) return dateString
        return dateString.replace(/\D/g, '').replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3');
    };

    const formatDateInputAPI = (dateString) => {
        if (!dateString) return dateString
        return dateString.replace(/\D/g, '').replace(/(\d{2})(\d{2})(\d{4})/, '$3-$1-$2');
    };

    const financialApp = async () => {
        try {
            const URL = HOST + appData.app_id

            const parsedFinancialData = {
                ...financialInfo,
                soldBusinessDate: formatDateInputAPI(financialInfo.soldBusinessDate)
            }

            const response = await apiClient.put(URL, {
                ...parsedFinancialData
            }, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                }
            })

            if (response.data && response.data.status &&
                ['400', '401', '403', '404', '405', '408', '429', '500', '501', '502', '503', '504', '505'].includes(response.data.status)) {
                throw new Error(response.data.message || 'Unknown error occurred');
            }
        } catch (error) {
            throw error;
        }
    }

    return (
        <div className="flex">
            <div className="left_side">
                <img className="w-full" src={financial} alt=""/>
            </div>

            <div className="right_side">
                <div className="flex justify-content-between align-items-baseline">
                    <div role="progressbar" id="combo" aria-label="progress" className="w-100">
                        <ProgressBar now={now} label={`${now}%`} visuallyHidden/>
                    </div>
                    <Logout/>
                </div>

                <p className="financial_heading text-center font-normal pb-3 text-xl">{t('financial.thanks')} {personalData.firstName} {personalData.lastName}. {t('financial.need_financial_info')}</p>

                <form onSubmit={handleSubmit}>

                    <div className="flex flex-column" style={{gap: "20px"}}>
                        {appData.account_type !== "speciality" && (
                            <div className="w-full">
                                <Form.Select aria-label="Default select example"
                                             name="emplStatus"
                                             value={financialInfo.emplStatus}
                                             onChange={handleInputChange}
                                >
                                    <option value="" disabled>{t('financial.employment_status')}</option>
                                    <option value="Employed">{t('financial.employed')}</option>
                                    <option value="SelfEmployed">{t('financial.self_employed')}</option>
                                    <option value="Retired">{t('financial.retired')}</option>
                                    <option value="Homemaker">{t('financial.homemaker')}</option>
                                    <option value="Student">{t('financial.student')}</option>
                                    <option value="Unemployed">{t('financial.unemployed')}</option>
                                </Form.Select>
                                {financialErrors.emplStatus &&
                                    <p className="text-red-600 text-xs mt-1 mb-0 text-start">{financialErrors.emplStatus}</p>}
                            </div>
                        )}

                        {financialInfo.emplStatus === 'Student' && (
                            <div>
                                <input type="text"
                                       className="financial_name_input flex w-full align-items-center gap-2"
                                       placeholder={t('financial.school_name')}
                                       name="schoolName"
                                       value={financialInfo.schoolName}
                                       onChange={handleInputChange}
                                />
                                {financialErrors.schoolName &&
                                    <p className="text-red-600 text-xs mt-1 mb-0 text-start">{financialErrors.schoolName}</p>}
                            </div>
                        )}
                    </div>
                    {(financialInfo.emplStatus === 'SelfEmployed' || financialInfo.emplStatus === 'Employed') && (
                        <div>
                            <div className="financial_employed flex flex-column gap-4 mt-4">
                                <div className="flex justify-content-between flex-wrap row-gap-3">
                                    <div className="financial_inp">
                                        <Form.Select aria-label="Default select example"
                                                     name="occupation"
                                                     value={financialInfo.occupation}
                                                     onChange={handleInputChange}
                                        >
                                            <option value="" disabled>{t('financial.occupation')}</option>
                                            <option value="Accounting">{t('financial.accounting')}</option>
                                            <option value="Agriculture">{t('financial.agriculture')}</option>
                                            <option value="Banking">{t('financial.banking_and_finance')}</option>
                                            <option value="Clerical">{t('financial.clerical')}</option>
                                            <option value="Construction">{t('financial.construction')}</option>
                                            <option value="Consulting">{t('financial.consulting')}</option>
                                            <option value="Customer Service">{t('financial.customer_service')}
                                            </option>
                                            <option value="Education">{t('financial.education')}</option>
                                            <option value="Engineering">{t('financial.engineer')}</option>
                                            <option value="Government">{t('financial.government')}</option>
                                            <option value="Healthcare">{t('financial.healthcare')}</option>
                                            <option value="Hotel">{t('financial.hotel_restaurant')}</option>
                                            <option value="Information Technology">{t('financial.information')}</option>
                                            <option value="Internet-E-Commerce">{t('financial.internet')}</option>
                                            <option value="Legal">{t('financial.legal')}</option>
                                            <option
                                                value="Management">{t('financial.management_executive')}</option>
                                            <option value="Manufacturing">{t('financial.manufacturing')}</option>
                                            <option value="Marketing">{t('financial.marketing')}</option>
                                            <option
                                                value="Media-Journalism-Newspaper-Magazine">{t('financial.media')}</option>
                                            <option value="Non-profit">{t('financial.non_profit')}</option>
                                            <option value="Real Estate">{t('financial.real_estate')}</option>
                                            <option value="Retail">{t('financial.retail')}</option>
                                            <option value="Sales">{t('financial.sales')}</option>
                                            <option value="Science">{t('financial.science')}</option>
                                            <option value="Security">{t('financial.security')}</option>
                                            <option value="Sports-Entertainment">{t('financial.sports')}</option>
                                            <option value="Travel-Leisure-Tourism">{t('financial.travel')}</option>
                                            <option value="Wholesale">{t('financial.wholesale')}</option>
                                        </Form.Select>
                                        {financialErrors.occupation &&
                                            <p className="text-red-600 text-xs mt-1 mb-0 text-start">{financialErrors.occupation}</p>}
                                    </div>

                                    <div className="financial_inp">
                                        <input type="number"
                                               className="financial_name_input flex w-full align-items-center gap-2 mb-0"
                                               placeholder="Business Phone"
                                               name="businessPhone"
                                               value={financialInfo.businessPhone}
                                               onChange={handleInputChange}
                                        />
                                        {financialErrors.businessPhone &&
                                            <p className="text-red-600 text-xs mt-1 mb-0 text-start">{financialErrors.businessPhone}</p>}
                                    </div>
                                </div>
                                <div className="flex justify-content-between flex-wrap row-gap-3">
                                    <div className="financial_inp">
                                        <input type="text"
                                               className="financial_name_input flex w-full align-items-center gap-2"
                                               placeholder={t('financial.company_name')}
                                               name="companyName"
                                               value={financialInfo.companyName}
                                               onChange={handleInputChange}
                                        />
                                        {financialErrors.companyName &&
                                            <p className="text-red-600 text-xs mt-1 mb-0 text-start">{financialErrors.companyName}</p>}
                                    </div>

                                    <div className="financial_inp">
                                        <input type="text"
                                               className="financial_name_input flex w-full align-items-center gap-2 mb-0"
                                               placeholder={t('financial.business_address')}
                                               name="businessAddress"
                                               value={financialInfo.businessAddress}
                                               onChange={handleInputChange}
                                        />
                                        {financialErrors.businessAddress &&
                                            <p className="text-red-600 text-xs mt-1 mb-0 text-start">{financialErrors.businessAddress}</p>}
                                    </div>
                                </div>
                                <div className="flex justify-content-between flex-wrap row-gap-3">
                                    <div className="financial_inp">
                                        <input type="text"
                                               className="financial_name_input flex w-full align-items-center gap-2"
                                               placeholder={t('financial.city')}
                                               name="city"
                                               value={financialInfo.city}
                                               onChange={handleInputChange}
                                        />
                                        {financialErrors.city &&
                                            <p className="text-red-600 text-xs mt-1 mb-0 text-start">{financialErrors.city}</p>}
                                    </div>
                                    <div className="financial_inp">
                                        {
                                            isReadyCountry ?
                                                <select
                                                    className="personal_country_select flex w-full align-items-center font-normal text-lg p-1 gap-2"
                                                    value={financialInfo.countryName}
                                                    onChange={(e) => onChangeCountry(e.target.value)}
                                                    name="countryName">
                                                    <option value="" disabled>{t('financial.select_country')}</option>
                                                    {countries.map((country, index) =>
                                                        <option value={country.value} key={index.toString()}>
                                                            {country.label}
                                                        </option>)}
                                                </select>
                                                : <Spinner animation="border" role="status" variant="personalData">
                                                    <span className="visually-hidden">Loading...</span>
                                                </Spinner>
                                        }
                                        {isReadyCountry && financialErrors.countryName &&
                                            <p className="text-red-600 text-xs mt-1 mb-0 text-start">{financialErrors.countryName}</p>
                                        }
                                    </div>
                                </div>
                                <div className="flex justify-content-between flex-wrap row-gap-3">
                                    <div className="financial_inp">
                                        <input type="text"
                                               className="financial_name_input flex w-full align-items-center gap-2"
                                               placeholder={t('financial.zip_code')}
                                               name="zipCode"
                                               value={financialInfo.zipCode}
                                               onChange={handleInputChange}
                                        />
                                        {financialErrors.zipCode &&
                                            <p className="text-red-600 text-xs mt-1 mb-0 text-start">{financialErrors.zipCode}</p>}
                                    </div>
                                    <div className="financial_inp" style={{textAlign: "center"}}>
                                        {
                                            isReadyState ?
                                                <select
                                                    className="personal_state_select flex w-full align-items-center font-normal text-lg p-1 gap-2"
                                                    onChange={(e) => onChangeState(e.target.value)}
                                                    name="businessState"
                                                    value={financialInfo.businessState}>
                                                    <option value="" disabled>{t('personal.select_state')}</option>
                                                    {states.map((state) => <option value={state.code}
                                                                                   key={state.code}>{state.subdivision_name}</option>)}
                                                </select>
                                                : <span></span>
                                        }
                                        {isReadyState && financialErrors.businessState &&
                                            <p className="text-red-600 text-xs mt-1 mb-0 text-start">{financialErrors.businessState}</p>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {(financialInfo.emplStatus === '' || financialInfo.emplStatus === 'Retired' || financialInfo.emplStatus === 'Homemaker' || financialInfo.emplStatus === 'Unemployed' || financialInfo.emplStatus === 'Student' || financialInfo.emplStatus === 'SelfEmployed' || financialInfo.emplStatus === 'Employed') &&
                        <div className="flex flex-column gap-4 mt-5">
                            <div>
                                <Form.Select aria-label="Default select example"
                                             name="sourceOfIncome"
                                             value={financialInfo.sourceOfIncome}
                                             onChange={handleInputChange}
                                >
                                    <option value="" disabled>{t('financial.source_of_income')}</option>
                                    <option value="Job">{t('financial.job')}</option>
                                    <option value="Personal Savings">{t('financial.personal_saving')}</option>
                                    <option value="Spouse/Parent">{t('financial.spouse')}</option>
                                    <option value="Social Security/Pension">{t('financial.security')}</option>
                                    <option value="Inheritance">{t('financial.inheritance')}</option>
                                    <option value="Investment">{t('financial.investment')}</option>
                                    <option value="Retirement Plan">{t('financial.retirement_plan')}</option>
                                    <option
                                        value="Real estate investment">{t('financial.real_estate_investment')}</option>
                                    <option value="Stock retirement annuity">{t('financial.stock_retirement')}</option>
                                    <option value="Family wealth">{t('financial.family_wealth')}</option>
                                    <option value="Passive income">{t('financial.passive_income')}</option>
                                    <option value="Royalties">{t('financial.royalties')}</option>
                                    <option value="Property income">{t('financial.property_income')}</option>
                                    <option value="Portfolio income">{t('financial.portfolio_income')}</option>
                                    <option value="Other">{t('financial.other')}</option>
                                </Form.Select>
                                {financialErrors.sourceOfIncome &&
                                    <p className="text-red-600 text-xs mt-1 mb-0 text-start">{financialErrors.sourceOfIncome}</p>}
                            </div>

                            <div>
                                <Form.Select aria-label="Default select example"
                                             name="sourceOfWealth"
                                             value={financialInfo.sourceOfWealth}
                                             onChange={handleInputChange}
                                >
                                    <option value="" disabled>{t('financial.source_of_wealth')}</option>
                                    <option
                                        value="Personal">{t('financial.personal_income_saving')}</option>
                                    <option value="Inheritance">{t('financial.inheritance')}</option>
                                    <option value="BusinessSale">{t('financial.sale_of_business')}</option>
                                </Form.Select>
                                {financialErrors.sourceOfWealth &&
                                    <p className="text-red-600 text-xs mt-1 mb-0 text-start">{financialErrors.sourceOfWealth}</p>}
                            </div>

                            {
                                financialInfo.sourceOfWealth === "BusinessSale" && (
                                    <>
                                        <div className="flex justify-content-between flex-wrap row-gap-4">
                                            <div className="financial_inp ">
                                                <input type="text"
                                                       className="financial_name_input flex w-full align-items-center gap-2"
                                                       placeholder={t('financial.sold_business_name')}
                                                       name="soldBusinessName"
                                                       value={financialInfo.soldBusinessName}
                                                       onChange={handleInputChange}
                                                />
                                                {financialErrors.soldBusinessName &&
                                                    <p className="text-red-600 text-xs mt-1 mb-0 text-start">{financialErrors.soldBusinessName}</p>}
                                            </div>

                                            <div className="financial_select">
                                                <Form.Select aria-label="Default select example"
                                                             name="soldAmount"
                                                             value={financialInfo.soldAmount}
                                                             onChange={handleInputChange}
                                                >
                                                    <option value="" disabled>{t('financial.sale_amount')}</option>
                                                    <option
                                                        value="$0-$1000000">$0-$1000000
                                                    </option>
                                                    <option value="$1000001-$10000000">$1000001-$10000000</option>
                                                    <option value="$10000000+">{t('financial.over')} $10000000+</option>
                                                </Form.Select>
                                                {financialErrors.sourceOfWealth &&
                                                    <p className="text-red-600 text-xs mt-1 mb-0 text-start">{financialErrors.sourceOfWealth}</p>}
                                            </div>
                                        </div>
                                        <div className="personal_input_full_error">
                                            <input className="personal_input_full"
                                                   placeholder={t('financial.date_sold')}
                                                   type="text"
                                                   name="soldBusinessDate"
                                                   value={formatDateInput(financialInfo.soldBusinessDate)}
                                                   onChange={handleInputChange}
                                            />
                                            {financialErrors.soldBusinessDate &&
                                                <p className="text-red-600 text-xs mt-1 mb-0 text-start">{financialErrors.soldBusinessDate}</p>}
                                        </div>
                                    </>
                                )
                            }

                            <div className="flex justify-content-between flex-wrap row-gap-4">
                                <div className="financial_select">
                                    <Form.Select aria-label="Default select example"
                                                 className="w-full"
                                                 name="annualIncome"
                                                 value={financialInfo.annualIncome}
                                                 onChange={handleInputChange}
                                    >
                                        <option value="" disabled>{t('financial.annual_income')}</option>
                                        <option value="A">$0 - $24,999</option>
                                        <option value="B">$25,000 - $74,999</option>
                                        <option value="C">$75,000 - $199,999</option>
                                        <option value="D">$200,000 - $499,999</option>
                                        <option value="E">$500,000 - $999,999</option>
                                        <option value="F">{t('financial.over')} $1,000,000</option>
                                    </Form.Select>
                                    {financialErrors.annualIncome &&
                                        <p className="text-red-600 text-xs mt-1 mb-0 text-start">{financialErrors.annualIncome}</p>}
                                </div>

                                <div className="financial_inp">
                                    <Form.Select aria-label="Default select example"
                                                 className="w-full"
                                                 name="assets"
                                                 value={financialInfo.assets}
                                                 onChange={handleInputChange}
                                    >
                                        <option value="" disabled>{t('financial.liquid_assets')}</option>
                                        <option value="A">$0 - $19,999</option>
                                        <option value="B">$20,000 - $49,999</option>
                                        <option value="C">$50,000 - $149,999</option>
                                        <option value="D">$150,000 - $499,999</option>
                                        <option value="E">$500,000 - $999,999</option>
                                        <option value="F">{t('financial.over')} $1,000,000</option>
                                    </Form.Select>
                                    {financialErrors.assets &&
                                        <p className="text-red-600 text-xs mt-1 mb-0 text-start">{financialErrors.assets}</p>}
                                </div>
                            </div>

                            <div>
                                <Form.Select aria-label="Default select example"
                                             name="netWorth"
                                             value={financialInfo.netWorth}
                                             onChange={handleInputChange}
                                >
                                    <option value="" disabled>{t('financial.net_worth')} </option>
                                    <option value="A">$0 - $19,999</option>
                                    <option value="B">$20,000 - $49,999</option>
                                    <option value="C">$50,000 - $149,999</option>
                                    <option value="D">$150,000 - $499,999</option>
                                    <option value="E">$500,000 - $999,999</option>
                                    <option value="F">{t('financial.over')} $1,000,000</option>
                                </Form.Select>
                                {financialErrors.netWorth &&
                                    <p className="text-red-600 text-xs mt-1 mb-0 text-start">{financialErrors.netWorth}</p>}
                            </div>
                        </div>
                    }

                    <div
                        className="flex sm:justify-content-between justify-content-center align-items-center sm:flex-row flex-column-reverse row-gap-3 pt-6">
                        <Link className="no-underline" to="/personal">
                            <button className="back_btn">{t('back_btn')}</button>
                        </Link>
                        <button className="continue_btn" type="submit">{t('next_btn')}</button>
                    </div>
                    <div>
                        {financialErrors.submitError && (
                            <div className="text-red-500 text-center">
                                {financialErrors.submitError}
                            </div>
                        )}
                    </div>
                </form>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    financialInfo: state.financialInfo,
    appData: state.appData,
    personalData: state.personalData
});

const mapDispatchToProps = {
    setFinancialInfo,
    setPersonalData,
    setAccountType
};

export default connect(mapStateToProps, mapDispatchToProps)(FinancialInfo);